// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500;1,600&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Red+Hat+Display:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
}
body {
  position: relative;
  min-height: 100%;
}

.container {
  width: 1230px;
  margin: 0 auto;
  max-width: 100vw;
  overflow: hidden;
}
.navContainer {
  width: 1510px;
  margin: 0 auto;
  overflow: hidden;
}

.footer_container {
  width: 1540px;
  margin: 0 auto;
  overflow: hidden;
}

.profile_page_container {
  width: 1200px;
  margin: 0 auto;
  padding: 26px 0;
  overflow: hidden;
}

.userContainer {
  width: 1270px;
  margin: 0 auto;
  overflow: hidden;
}

.profile_container {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  overflow: hidden;
}

.link_container {
  width: 980px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 31px;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
    box-shadow: 0 0 0 50px rgba(#5a99d4, 0) !important;
  }

  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 50px rgba(#5a99d4, 0) !important;
  }
}

@media only screen and (max-width: 1565px) and (min-width: 1166px) {
  .navContainer {
    width: 1466px !important;
    margin: 0 auto !important;
    overflow: hidden;
    padding: 30px !important;
  }
  .footer_container {
    width: 100% !important;
    margin: 0 auto !important;
    overflow: hidden;
    padding: 0px 30px !important;
  }
  .userContainer {
    width: 100% !important;
    margin: 0 auto !important;
    overflow: hidden;
    padding: 0px 50px !important;
  }
}
@media only screen and (min-width: 1666px) {
}
@media only screen and (max-width: 1024px) and (min-width: 215px) {
  .container {
    width: 100% !important;
    margin: 0 auto !important;
    padding: 29px;
    overflow: hidden;
  }

  .navContainer {
    width: 100%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .container {
    width: 95vw !important;
    margin: 0 auto !important;
  }
}

li {
  list-style-type: none;
}

a {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,qBAAqB;IACrB,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;AACA;AACA;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500;1,600&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Red+Hat+Display:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n@import url(\"https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n}\nbody {\n  position: relative;\n  min-height: 100%;\n}\n\n.container {\n  width: 1230px;\n  margin: 0 auto;\n  max-width: 100vw;\n  overflow: hidden;\n}\n.navContainer {\n  width: 1510px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.footer_container {\n  width: 1540px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.profile_page_container {\n  width: 1200px;\n  margin: 0 auto;\n  padding: 26px 0;\n  overflow: hidden;\n}\n\n.userContainer {\n  width: 1270px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.profile_container {\n  width: 1200px;\n  margin: 0 auto;\n  padding: 30px 0;\n  overflow: hidden;\n}\n\n.link_container {\n  width: 980px;\n  margin: 0 auto;\n  overflow: hidden;\n  margin-top: 31px;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.9);\n  }\n  50% {\n    transform: scale(1);\n    box-shadow: 0 0 0 50px rgba(#5a99d4, 0) !important;\n  }\n\n  100% {\n    transform: scale(0.9);\n    box-shadow: 0 0 0 50px rgba(#5a99d4, 0) !important;\n  }\n}\n\n@media only screen and (max-width: 1565px) and (min-width: 1166px) {\n  .navContainer {\n    width: 1466px !important;\n    margin: 0 auto !important;\n    overflow: hidden;\n    padding: 30px !important;\n  }\n  .footer_container {\n    width: 100% !important;\n    margin: 0 auto !important;\n    overflow: hidden;\n    padding: 0px 30px !important;\n  }\n  .userContainer {\n    width: 100% !important;\n    margin: 0 auto !important;\n    overflow: hidden;\n    padding: 0px 50px !important;\n  }\n}\n@media only screen and (min-width: 1666px) {\n}\n@media only screen and (max-width: 1024px) and (min-width: 215px) {\n  .container {\n    width: 100% !important;\n    margin: 0 auto !important;\n    padding: 29px;\n    overflow: hidden;\n  }\n\n  .navContainer {\n    width: 100%;\n    margin: 0 auto;\n  }\n}\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n  .container {\n    width: 95vw !important;\n    margin: 0 auto !important;\n  }\n}\n\nli {\n  list-style-type: none;\n}\n\na {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
